import { type ApplicationModes } from '../../constants/application-modes';

export const onHighlightedWithKeyboard: (
	index: number,
	applicationMode: ApplicationModes,
) => {
	type: string;
	data: {
		actionSubject: string;
		action: string;
		source: string;
		attributes: {
			index: number;
			mode: ApplicationModes;
		};
	};
} = (index: number, applicationMode: ApplicationModes) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'highlighted',
			source: 'fullPageSearch',
			attributes: {
				index,
				mode: applicationMode,
			},
		},
	};
};
